import { Tone } from 'generated-graphql/types';

export type AgentToneOption = {
  label: string;
  value: Tone;
};

export const AGENT_TONE_OPTIONS: AgentToneOption[] = [
  {
    label: 'Neutral',
    value: Tone.Neutral
  },
  {
    label: 'Casual/fun',
    value: Tone.Casual
  },
  {
    label: 'Friendly',
    value: Tone.Friendly
  },
  {
    label: 'Motivational',
    value: Tone.Motivational
  },
  {
    label: 'Professional',
    value: Tone.Professional
  }
];
